module.exports = __webpack_public_path__ + "img/apiq.b9bc08e3.png";